import React, { useState, useEffect } from 'react';
import KnotWatermark from '../illustrations/KnotWatermark';

const aboutImages = ['/assets/about-1.jpeg', '/assets/about-2.jpeg', '/assets/about-3.jpeg'];

export default function About() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setCurrent(prev => (prev + 1) % aboutImages.length), 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="sobre-inerva" className="section-padding bg-white relative overflow-hidden">
      <KnotWatermark position="center" />
      <div className="container-narrow relative">
        <div className="max-w-5xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div>
          <h2 className="mb-6">Qué es Inerva</h2>

          <div className="space-y-5 text-[var(--color-inerva-text-light)]">
            <p>
              Inerva es una <strong className="text-[var(--color-inerva-forest)]">clínica online de psicología para personas adultas</strong>.
              Un espacio seguro donde no se juzga ni se patologiza la experiencia. No creemos en soluciones rápidas o mágicas:
              creemos en procesos reales, sostenibles y respetuosos con el ritmo de cada persona.
            </p>
            <p>
              En Inerva no trabajamos sobre la persona, sino <strong className="text-[var(--color-inerva-forest)]">con la persona</strong>.
              Nuestro objetivo no es "arreglar" a nadie, sino acompañar a construir una vida más habitable, con mayor sentido,
              calma y coherencia.
            </p>
            <p>
              Trabajamos especialmente con personas que atraviesan ansiedad, crisis vitales (duelos, rupturas, trauma,
              cambios importantes) y procesos de identidad. También ofrecemos un{' '}
              <strong className="text-[var(--color-inerva-forest)]">acompañamiento afirmativo para el colectivo LGTBIQA+</strong>,
              con perspectiva de género y atención a las experiencias de discriminación, estrés minoritario y heridas relacionales.
            </p>
            <p>
              Además, Inerva nace con vocación comunitaria: entendemos la salud mental conectada con el contexto, los vínculos,
              las condiciones de vida y la diversidad de familias y realidades.
            </p>
          </div>
          </div>
          <div className="hidden lg:block">
            <div className="relative aspect-[6/7] rounded-[var(--radius-xl)] overflow-hidden">
              {aboutImages.map((src, i) => (
                <img
                  key={src}
                  src={src}
                  alt={`Inerva Psicología ${i + 1}`}
                  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${i === current ? 'opacity-100' : 'opacity-0'}`}
                  loading={i === 0 ? 'eager' : 'lazy'}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
